export default "__VITE_ASSET__BS8YY1F___"